import React, { useContext, useEffect } from 'react'
import Layout from '../Layout'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import StandaloneVehicle from '../../../Component/SlidePanel/StandaloneVehicle'
import './ProductViewStandalone.css'

const ProductView = () => {
    return (
        <Layout>
            <div className="productViewStandalone customContainer">
                <StandaloneVehicle storeTheme="LiquidationPallet" />
            </div>
        </Layout>
    )
}

export default ProductView
